import { AxiosInstance, AxiosRequestConfig } from 'axios'

import { ServiceOfferRepository } from './domain'

import { LocalizedGroupServiceOfferView, ServiceOfferDetailsView } from '../../contracts/service-offer'
import { AxiosErrorHandler } from '../../foundation'

export class PartnerApiServiceOfferRepository implements ServiceOfferRepository {
  private errorHandler: AxiosErrorHandler

  constructor(private axios: AxiosInstance) {
    this.errorHandler = new AxiosErrorHandler()
  }

  searchByTitle = async (title: string): Promise<LocalizedGroupServiceOfferView[]> => {
    const config: AxiosRequestConfig<{ title: string }> = {
      url: '/service-offer/query/partner/groups/process',
      method: 'post',
      data: { title },
    }

    try {
      const { data } = await this.axios.request<LocalizedGroupServiceOfferView[]>(config)
      return data
    } catch (error) {
      return this.errorHandler.handle(error)
    }
  }

  getById = async (id: number): Promise<ServiceOfferDetailsView> => {
    const config: AxiosRequestConfig<{ id: number }> = {
      url: '/service-offer/query/partner/get-service-offer/process',
      method: 'post',
      data: { id },
    }

    try {
      const { data } = await this.axios.request<ServiceOfferDetailsView>(config)
      return data
    } catch (error) {
      return this.errorHandler.handle(error)
    }
  }

  deactivate = async (id: number): Promise<void> => {
    const config: AxiosRequestConfig<{ id: number }> = {
      url: '/service-offer/command/partner/deactivate/execute',
      method: 'post',
      data: { id },
    }

    try {
      await this.axios.request<void>(config)
    } catch (error) {
      return this.errorHandler.handle(error)
    }
  }

  modifyPeriod = async (id: number, endsAtUtc?: string): Promise<void> => {
    const config: AxiosRequestConfig<{ id: number; endsAtUtc?: string }> = {
      url: '/service-offer/command/partner/modify-period/execute',
      method: 'post',
      data: { id, endsAtUtc },
    }

    try {
      await this.axios.request<void>(config)
    } catch (error) {
      return this.errorHandler.handle(error)
    }
  }
}
